import { ISkillTabs } from '../../libs/utils/interfaces/skill-launch-interface';

// Do not change Specialities's spelling, it is coming from the backend
export const HSearchContentType = {
    CLINICALSKILLS: 'Clinical Skills',
    PATIENTEDUCATION: 'Patient Education',
};

export const HSearchFilters: any = {
    CONTENTTYPE: 'Content type',
    AGESPECIFIC: 'Age',
    CATEGORIES: 'Categories',
    SPECIALITIES: 'Specialties',
    PATIENTEDUCATIONTYPE: 'Patient Education Type',
};

export const HSearchDefaultFacetData = {
    facetName: HSearchFilters.CONTENTTYPE,
    facetValues: [
        {
            name: HSearchContentType.CLINICALSKILLS,
        },
        {
            name: HSearchContentType.PATIENTEDUCATION,
        },
    ],
};

export const PESearchFilter: any = [
    {
        title: 'PE type',
        name: HSearchFilters.PATIENTEDUCATIONTYPE,
    },
    {
        title: 'Specialties',
        name: HSearchFilters.SPECIALITIES,
    },
];

export const NSKSearchFilter: any = [
    {
        title: 'Age-specific population',
        name: HSearchFilters.AGESPECIFIC,
    },
    {
        title: 'Specialties',
        name: HSearchFilters.SPECIALITIES,
    },
    {
        title: 'Category',
        name: HSearchFilters.CATEGORIES,
    },
];

export const HSearchFilterDisplayName: any = {
    'Content type': 'Content type',
    Age: 'Age-specific population',
    Categories: 'Categories',
    Specialties: 'Specialities',
    'Patient Education Type': 'PE type',
};

export const NumberNotDisplayTitles = [
    HSearchFilters.PATIENTEDUCATIONTYPE,
    HSearchFilters.CONTENTTYPE,
];

export const AgeFilterTitles = {
    1: ['Neonatal', '+age:1'],
    2: ['Pediatric', '+age:2'],
    3: ['Adult', '+age:3'],
};

export const PatientEducationTypeTitles = {
    MEDICATION: 'Medication',
    CONDITION: 'Condition',
};

export const HSearchRadioButtonTypeName = {
    'Content type': 'contentType',
    'Patient Education Type': 'subType',
    Specialties: 'speciality',
    Age: 'ageSpecific',
    Categories: 'category',
};

export const getFacetValueFromFacetData = (
    name: string,
    facetValueObj: any
) => {
    let facetValue = facetValueObj?.of || '';
    if (facetValue === '' && name === HSearchFilters.AGESPECIFIC) {
        const agefilter = Object.values(AgeFilterTitles).find(
            ([label]) => label === facetValueObj?.name
        );
        if (agefilter) {
            const [, ageFilterValue] = agefilter;
            facetValue = ageFilterValue;
        }
    }
    return facetValue?.split('+')[1] || facetValue;
};

export const defaultVisibleItems: number = 5;

export const SkillsTabIndexes: ISkillTabs = {
    Notes: '0',
    QuickSheet: '1',
    ExtendedText: '2',
    Videos: '4',
    Illustrations: '5',
};
